import React from 'react';
import InquiryForm from './InquiryForm';

interface BannerProps {
  title: string;
  subtitle: string;
  backgroundImage: string;
  showForm?: boolean;
}

const Banner: React.FC<BannerProps> = ({ 
  title, 
  subtitle, 
  backgroundImage,
  showForm = false
}) => {
  return (
    <div 
      className="relative bg-cover bg-center pt-28 pb-16 md:pt-36 md:pb-24" 
      style={{ 
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(${backgroundImage})` 
      }}
    >
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div className="text-white">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 text-white">
              {title}
            </h1>
            <p className="text-lg md:text-xl text-gray-200 mb-8">
              {subtitle}
            </p>
            {!showForm && (
              <div className="flex flex-wrap gap-4">
                <a 
                  href="tel:+917389205299" 
                  className="btn btn-secondary text-primary-800 font-semibold"
                >
                  Call Now
                </a>
                <a 
                  href="#contact-section" 
                  className="btn btn-outline border-white text-white hover:bg-white hover:text-primary-700"
                >
                  Get in Touch
                </a>
              </div>
            )}
          </div>
          
          {showForm && (
            <div className="bg-white rounded-lg shadow-lg p-6 md:p-8">
              <h3 className="text-xl font-semibold text-primary-700 mb-4">
                Request Information
              </h3>
              <InquiryForm />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Banner;